import React, { Component } from 'react';
import { Row, Col, Card, CardHeader, CardBody, ListGroup, ListGroupItem, ListGroupItemHeading, Badge } from 'reactstrap';
import CorporateModal from '../../components/UI/CorporateModal';
import './sidebar.scss';
import { MODAL_TYPE_SUCCESS, LONG_DATE_FORMAT } from "../../constants";
import { getAlertList, getGeneralNewsList, updateReadStatus } from "./action";
import { connect } from 'react-redux';
import moment from 'moment';
import { getAlertCount } from './helper';
import { NEWSFEED } from './constants';
import { goolgeAnalyticsEvents } from '../../components/GoogleAnalytics/index';

class Sidebar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            body: null,
            modalType: MODAL_TYPE_SUCCESS,
            modalTitle: '',
            modalCloseHandler: () => { },
            alertListSuccess: [],
            generalNewsListSuccess: [],
            alertCount: ''
        };
    }

    componentDidMount() {
        this.props.getALertList();
        this.props.getGeneralNewsList();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.alertListSuccess !== this.props.alertListSuccess) {
            const alertTempCount = getAlertCount(this.props.alertListSuccess)
            this.setState({
                alertListSuccess: this.props.alertListSuccess,
                alertCount: alertTempCount
            });
            this.props.portfolioAlertcallback(alertTempCount)
        }
        if (prevProps.generalNewsListSuccess !== this.props.generalNewsListSuccess) {
            this.setState({ generalNewsListSuccess: this.props.generalNewsListSuccess })
        }
    }

    toggleModal = () => {
        this.setState(prevState => ({
            showModal: !prevState.showModal,
            body: null
        }));
    }
    showAlertDetails = (alertListItem) => {
        this.props.updateReadStatus(alertListItem.alertId);
        if (alertListItem.newsAlertType === NEWSFEED) {
            goolgeAnalyticsEvents('Corporate', 'View Newsfeed Alerts', 'Newsfeed Alerts', '');
            this.setState({
                showModal: true,
                body: <div className="modal-alert-details">
                    <h5 className="mb-4 mb-sm-3 font-weight-bold">{alertListItem.title}</h5>
                    <p className="mb-5">
                        {alertListItem.details}
                        <a href={alertListItem.sourceURL} target="_blank" rel="noreferrer">
                            Read More
                        </a>
                    </p>
                    <Row className="mb-4 mb-sm-3" noGutters>
                        <Col sm='5'>
                            <label>Counterparties :</label>
                        </Col>
                        <Col sm='19' className="d-flex flex-wrap pl-0">
                            <span className="mr-2 mb-2 filter-item">{alertListItem.counterpartyName}</span>
                        </Col>
                    </Row>
                    <Row noGutters>
                        <Col sm='5'>
                            <label>Keywords :</label>
                        </Col>
                        <Col sm='19' className="d-flex flex-wrap pl-0">
                            {(alertListItem.newsFeedKeyWordList) ?
                                alertListItem.newsFeedKeyWordList.map((item, index) => {
                                    return (
                                        <span key={index} className="mr-2 mb-2 filter-item">{item.keyword}</span>
                                    )
                                }) : ''}
                        </Col>
                    </Row>
                </div>,
                modalType: MODAL_TYPE_SUCCESS,
                modalTitle: 'Alert Details',
                modalCloseHandler: this.toggleModal
            });
        } else {
            goolgeAnalyticsEvents('Corporate', 'View Portfolio Alerts', 'Portfolio Alerts', '');
            this.props.history.push('/my-portfolio/1');
        }

    }

    render() {
        return (
            <div className="app-sidebar">
                <Card className="pb-3 border-bottom shadow-none card-alerts">
                    <CardHeader className="bg-light portfolio-alerts-text app-sidebar__header" style={{ '--primaryColor': this.props.corporateColor }}>
                        Portfolio Alerts <Badge className="portfolio-alerts-badge d-none d-sm-inline-block" style={{ '--primaryColor': this.props.corporateColor }}>{this.state.alertCount}</Badge>
                        <time className="d-block app-sidebar__header-datetime">{moment().format(LONG_DATE_FORMAT)}</time>
                    </CardHeader>
                    <CardBody className="pt-0">
                        <ListGroup>
                            {
                                this.state.alertListSuccess.map(alertListItem => {
                                    return (
                                        <ListGroupItem onClick={() => this.showAlertDetails(alertListItem)} key={alertListItem.alertId}>
                                            <ListGroupItemHeading>
                                                <span className={(alertListItem.viewed === false) ? 'font-weight-bold font-italic pointer' : 'font-weight-normal pointer'}>{alertListItem.title}</span>
                                            </ListGroupItemHeading>
                                        </ListGroupItem>
                                    )
                                })
                            }

                        </ListGroup>
                    </CardBody>
                </Card>
                <Card className="pb-3 shadow-none card-news card-alerts">
                    <CardHeader className="bg-light portfolio-alerts-text app-sidebar__header" style={{ '--primaryColor': this.props.corporateColor }}>
                        News Feeds
                        <time className="d-block app-sidebar__header-datetime">{moment().format(LONG_DATE_FORMAT)}</time>
                    </CardHeader>
                    <CardBody className="pt-0">
                        <ListGroup>
                            {this.state.generalNewsListSuccess.map((newsListItem, index) => {
                                return (
                                    <ListGroupItem key={index}>
                                        <ListGroupItemHeading><a href={newsListItem.sourceUrl} target="_blank" rel="noreferrer">{newsListItem.title}</a></ListGroupItemHeading>
                                    </ListGroupItem>
                                )
                            })}

                        </ListGroup>
                    </CardBody>
                </Card>
                <CorporateModal toShow={this.state.showModal}
                    modalClosed={this.state.modalCloseHandler}
                    modalType={this.state.modalType}
                    body={this.state.body}
                    title={this.state.modalTitle} />
            </div>
        );
    }
}


const mapStateToProps = (state, props) => ({
    alertListSuccess: state.alertsReducer.alertListSuccess,
    generalNewsListSuccess: state.alertsReducer.generalNewsListSuccess
})
const mapDispatchToProps = (dispatch, props) => ({
    getALertList: () => dispatch(getAlertList()),
    getGeneralNewsList: () => dispatch(getGeneralNewsList()),
    updateReadStatus: (id) => { dispatch(updateReadStatus(id)) }
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Sidebar);

